/* unplugin-vue-components disabled */import script from "./reserve_Qj.vue?vue&type=script&setup=true&lang=ts"
export * from "./reserve_Qj.vue?vue&type=script&setup=true&lang=ts"

import "./reserve_Qj.vue?vue&type=style&index=0&id=d14960c0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d14960c0"]])

export default __exports__